import React, { Component } from 'react';
import FontAwesome from 'react-fontawesome'

class kegOption extends Component {
  constructor(props) {
    super(props)
    this.state = {
      hover: false
    }
  }

  toggleHoverOn = () => {
    this.setState({ hover: true })
  }

  toggleHoverOff = () => {
    this.setState({ hover: false })
  }

  selectedId = () => {
    return this.props.selectedKeg
      && this.props.selectedKeg.value
      && this.props.selectedKeg.value.id
  }

  selectedKegSizeId = () => {
    return this.props.selectedKeg
      && this.props.selectedKeg.value
      && this.props.selectedKeg.value.keg_size_id
  }

  selectedInventoryType = () => {
    return this.props.selectedKeg
      && this.props.selectedKeg.value
      && this.props.selectedKeg.value.inventory_type
  }

  selectedIndex = () => {
    console.log(this.props.selectedKeg)
    return this.props.selectedKeg
      && this.props.selectedKeg.value
      && this.props.selectedKeg.value.index
  }

  inventoryType = () => {
    return this.props.option
      && this.props.option.value
      && this.props.option.value.inventory_type
  }

  productId = () => {
    return this.props.option
      && this.props.option.value
      && this.props.option.value.id
  }

  kegSizeId = () => {
    return this.props.option
      && this.props.option.value
      && this.props.option.value.keg_size_id
  }

  kegIndex = () => {
    console.log(this.props.option)
    return this.props.option
      && this.props.option.value
      && this.props.option.value.index
  }

  render () {
    let selected = this.selectedId() === this.productId() && this.selectedKegSizeId() === this.kegSizeId() && this.inventoryType() === this.selectedInventoryType() && this.selectedIndex() === this.kegIndex()
    return (
      <div
        key={`kegoption - ${this.props.option.value.id} - ${this.props.index}`}
        onClick={ () => selected ? this.props.unselectKeg(this.props.kegNumber, this.props.option) : this.props.selectKeg(this.props.kegNumber, this.props.option) }
        onMouseEnter={ this.toggleHoverOn }
        onMouseOut={ this.toggleHoverOff }
        style={{
          height: 30,
          display: 'flex',
          width: 315,
          justifyContent: 'space-between',
          alignItems: 'center',
          cursor: 'pointer',
          marginTop: -.1,
          marginBottom: .1,
          color: selected ? 'white' : 'black',
          backgroundColor: this.state.hover ? 'lightgray' : selected ? 'gray' : '#f9f9f9'
      }}>
        <div style={{ lineHeight: '30px', height: 30, margin: 5 }}>
          { this.props.option.label }
        </div>
        { selected &&
          <div>
            <FontAwesome
              style={{ color: 'white', lineHeight: '30px', height: 30, margin: 5 }}
              className='check'
              name='check'/>
          </div>
        }
      </div>
    )
  }
}

export default kegOption



// WEBPACK FOOTER //
// ./src/Reservations/KegOption.jsx